<template>
  <div class="work-us default-page">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row filter-row">
                <div class="col-12 title-col">
                  <h3>Trabalhe conosco</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label for>
                      Nome
                      <span class="required-field">*</span>
                    </label>
                    <input type="text" v-model="email.name" class="form-control" />
                  </div>
                  <div class="form-group">
                    <label for>
                      Email
                      <span class="required-field">*</span>
                    </label>
                    <input type="text" v-model="email.email" class="form-control" />
                  </div>
                  <div class="form-group">
                    <label for>
                      Telefone
                      <span class="required-field">*</span>
                    </label>
                    <input
                      type="text"
                      v-model="email.phone"
                      v-mask="'(##) #####-####'"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group">
                    <label for>
                      Mensagem
                      <span class="required-field">*</span>
                    </label>
                    <textarea cols="30" v-model="email.message" rows="5" class="form-control"></textarea>
                  </div>
                  <div class="form-group">
                    <label for>
                      Anexar um Currículo
                      <span class="required-field">*</span>
                    </label>
                    <b-form-file
                      placeholder="Escolha um arquivo"
                      drop-placeholder="Arraste o arquivo aqui..."
                      browse-text="Procurar"
                      accept="application/pdf"
                      v-on:change="uploadFile"
                    ></b-form-file>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <button class="btn btn-primary float-right" v-on:click="send()">Enviar mensagem</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import work_us_validate from "@/imports/validator/models/work_us";
import validator from "@/imports/validator/validate";
import { bus } from "@/main";

export default {
  name: "work-us",
  data() {
    return {
      tempFile: '',
      email: {
        subject: "Tenho interesse em trabalhar na Governet"
      }
    };
  },
  methods: {
    send: function() {
      this.email.file = this.tempFile;
      let errors = validator.validate(this.email, work_us_validate.model);
      if (errors.length == 0) {
        bus.$emit("changeLoading", true);
        let promise = axios.post(
          `${process.env.VUE_APP_API_HOST}/api/contact_us`,
          this.email
        );
        promise
          .then(response => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Mensagem enviada com sucesso",
              icon: "success",
              onClose: () => {
                this.$router.push({ name: "Home" });
              }
            });
          })
          .catch(error => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Ocorreu um erro.",
              icon: "error"
            });
          });
      } else {
        let html = "Preencha todos os campos obrigatórios.";
        if (errors.length < 4) {
          html = "";
          errors.forEach(el => (html += el.message + "<br>"));
        }
        Swal.fire({
          title: "Atenção",
          html: html,
          icon: "warning"
        });
      }
    },
    uploadFile: function(e) {
      const file = e.target.files[0];
      if (!file.type.includes("/pdf")) {
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          this.tempFile = event.target.result;
        };
        reader.readAsDataURL(file);
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";

.work-us {
  .title-col {
    text-align: center;
  }
}
</style>